import type { ReactElement } from 'react';
import { Tooltip } from '@mantine/core';

/**
 * When a button is disabled, wrap it in a Tooltip explaining why. The
 * wrapping <span> is required so Mantine's Tooltip can attach hover/focus
 * listeners — `disabled` buttons don't fire events themselves, but the span
 * does. `events.touch=true` makes it accessible on touch devices too. With no
 * reasons the button renders as-is, so the tooltip doesn't pop on hover.
 */
export function DisabledReasonTooltip({
  reasons,
  children,
}: {
  reasons: string[];
  children: ReactElement;
}) {
  if (reasons.length === 0) return children;
  const label =
    reasons.length === 1 ? reasons[0] : reasons.map(r => `• ${r}`).join('\n');
  return (
    <Tooltip
      label={label}
      multiline
      w={320}
      withArrow
      events={{ hover: true, focus: true, touch: true }}
    >
      <span style={{ display: 'inline-block', cursor: 'not-allowed' }}>
        {children}
      </span>
    </Tooltip>
  );
}
